// extracted by mini-css-extract-plugin
export var logo = "_a6-2";
export var logoWrapper = "_a6-1";
export var strip = "_a6-0";